import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

interface UseCopyToClipboardProps {
  value: string;
}

export const useCopyToClipboard = ({ value }: UseCopyToClipboardProps) => {
  const [copied, setCopied] = React.useState<boolean>(false);

  const handleCopy = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      void navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (err) {
      // ignore error

      console.error(err);
    }
  };

  React.useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false);
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    }

    return undefined;
  }, [copied]);

  return {
    handleCopy,
    copied,
    isCopyDisabled: isEmpty(value),
  };
};
